import React from 'react';
import { Link } from 'react-router-dom';
import { Icon } from './Icon';
import { LucideIcon } from 'lucide-react';

interface NavLinkProps {
  to: string;
  icon: LucideIcon;
  title?: string;
  className?: string;
  onClick?: () => void;
  children?: React.ReactNode;
}

export const NavLink: React.FC<NavLinkProps> = ({
  to,
  icon,
  title,
  className = '',
  onClick,
  children
}) => {
  return (
    <Link
      to={to}
      title={title}
      onClick={onClick}
      className={`
        flex items-center px-2 py-2 text-sm font-medium
        text-white hover:text-gray-200 transition-colors
        ${className}
      `}
    >
      <Icon icon={icon} className="flex-shrink-0" />
      {children && <span className="ml-2">{children}</span>}
    </Link>
  );
};
